"use client";

import { Bookmark, Camera, MapPin, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import type { Post } from "@/data/demo";

export function PostRow({ post }: { post: Post }) {
  const [saved, setSaved] = useState(false);
  return (
    <article className="post-row listing-row">
      <Link
        className="listing-link"
        to={`/posts/${post.id}`}
        aria-label={`Open ${post.title}`}
      >
        <div
          className={`listing-photo ${post.accountType === "Couple" ? "couple" : ""}`}
          aria-label="Listing photo placeholder"
        >
          <span>{post.initials}</span>
          <Camera size={16} />
          <small>3</small>
        </div>
        <div className="post-main">
          <h3 className="post-title">{post.title}</h3>
          <div className="listing-location">
            <MapPin size={14} /> {post.location} · {post.distance}
          </div>
          <p className="post-copy">{post.description}</p>
          <div className="listing-meta">
            <span>{post.posterType} → {post.seeking.join(", ")}</span>
            <span>{post.category}</span>
            {post.owner === "Lena & Ash" && (
              <span className="verified">
                <ShieldCheck size={13} /> Established
              </span>
            )}
            <time>{post.freshness}</time>
          </div>
        </div>
      </Link>
      <button
        className="save-listing"
        type="button"
        onClick={() => setSaved(!saved)}
        aria-label={saved ? "Remove saved Post" : "Save Post"}
      >
        <Bookmark size={19} fill={saved ? "currentColor" : "none"} />
      </button>
    </article>
  );
}
